import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/auth',
            name: 'auth',
            component: () => import('../views/auth/Auth.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/pay',
            name: 'pay',
            component: () => import('../views/pay/pay.vue'),
            meta: {title: '支付', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/success',
            name: 'success',
            component: () => import('../views/success/success.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/success11',
            name: 'success11',
            component: () => import('../views/success11/success11.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/success112',
            name: 'success112',
            component: () => import('../views/success112/success112.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/successH',
            name: 'successH',
            component: () => import('../views/successH/successH.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/share',
            name: 'share',
            component: () => import('../views/share/share.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/shareNew',
            name: 'shareNew',
            // component: () => import('../views/shareNew/shareNew.vue'),
            component: () => import('../views/newShare/newShare.vue'),

            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/sharePublic',
            name: 'sharePublic',
            component: () => import('../views/sharePublic/sharePublic.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/cervical',
            name: 'cervical',
            component: () => import('../views/cervical/cervical.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/redirectUri',
            name: 'redirectUri',
            component: () => import('../views/redirectUri/redirectUri.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/jump',
            name: 'jump',
            component: () => import('../views/jump/jump.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/jumpNew',
            name: 'jumpNew',
            component: () => import('../views/jumpNew/jumpNew.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/authority',
            name: 'authority',
            component: () => import('../views/authority/Authority.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/jumpGongan',
            name: 'jumpGongan',
            component: () => import('../views/authority/jumpGongan.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/insurancePayment',
            name: 'insurancePayment',
            component: () => import('../views/insurancePayment/index.vue'),
            meta: {title: '用户授权', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/insurance/demo',
            name: 'insuranceDemo',
            component: () => import('../views/insurancePayment/demo.vue'),
            meta: {title: '用户授权', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/impower',
            name: 'impower',
            component: () => import('../views/impower/impower.vue'),
            meta: {title: '医患服务平台', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/login/Login.vue'),
            meta: {title: '登录', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/privacyPolicy',
            name: 'privacyPolicy',
            component: () => import('../views/privacyPolicy/privacyPolicy.vue'),
            meta: {title: '医患服务平台隐私协议', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/iframePage',
            name: 'iframePage',
            component: () => import('../views/iframePage/iframePage.vue'),
            meta: {title: '', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/jump/qyPatient',
            name: 'qyPatient',
            component: () => import('../views/jump/qyPatient.vue'),
            meta: {title: '添加医生助理', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {
            path: '/patientSilentLogin',
            name: 'patientSilentLogin',
            component: () => import('../views/patientSilentLogin/PatientSilentLogin.vue'),
            meta: {title: '患者静默登录', isKeepAlive: false, requireAuth: false, assign: false},
        },
        {path: '**', name: '404', component: () => import('../core/exception/404.vue'), meta: {title: '医患服务平台'}},
    ],
});


